module.exports = __webpack_public_path__ + "./images/6ea277fd6804319f278281042a29ea27.webp";